import $ from 'jquery';
window.$ = $;
window.jQuery = $;
/**
 * Init this module.
 */
const loadDeferredEmbeds = () => {
	document.querySelectorAll('.media-grid-embed-container iframe[data-src]').forEach((iframe) => {
		iframe.src = iframe.dataset.src;
	});
};

const init = () => {
	window.addEventListener('load', loadDeferredEmbeds);

	const videos = $('.media-grid video');

	videos.each((index, vid) => {
		const video = $(vid);
		const button = video.siblings('button');

		button.on('click', () => {
			const current = video.get(0);
			button.toggleClass('pause');
			if (current.paused) {
				current.play();
			} else {
				current.pause();
			}
		});
	});

	const next = $('.module-media').next();
	const prev = $('.module-media').prev();

	$(next).addClass('adjacent-below');
	$(prev).addClass('adjacent-above');

	if (!$(next).next().hasClass('module-media')) {
		$(next).addClass('nothing-below');
	}

	if (!$(prev).prev().hasClass('module-media')) {
		$(prev).addClass('nothing-above');
	}
};

export default init;
